import { Add, Delete } from "@mui/icons-material";
import {
  Autocomplete,
  Button,
  Card,
  CardContent,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { Controller, useFieldArray } from "react-hook-form";
import ConfigClassificationQuery from "./ConfigClassificationQuery";
import { defaultClassificationQuery } from "./ConfigDefault";
import { useFormConfigContext } from "./ConfigFormContext";

interface ConfigClassificationRoutedQueryProps {
  index: number;
  removeRouted: Function;
  routes: string[];
}

const ConfigClassificationRoutedQuery: React.FC<
  ConfigClassificationRoutedQueryProps
> = ({ index, removeRouted, routes }) => {
  const { control } = useFormConfigContext();
  const {
    fields: queries,
    append: addQuery,
    remove: removeQuery,
  } = useFieldArray({
    control,
    name: `config.classification.queries.${index}.queries`,
  });

  return (
    <Card className="m-1 overflow-visible">
      <CardContent>
        <Stack rowGap={2}>
          <div className="flex justify-between items-center">
            <Typography className="text-xl font-semibold">
              Classifications après découpage
            </Typography>
            <div className="flex gap-2">
              <Button
                variant="contained"
                onClick={() => addQuery(defaultClassificationQuery())}
              >
                <Add />
                Classification
              </Button>
              <Button color="error" onClick={() => removeRouted()}>
                <Delete color="error" />
              </Button>
            </div>
          </div>
          <Controller
            render={({ field: { onChange, ...props } }) => (
              <Autocomplete
                multiple
                options={Object.values(routes)}
                getOptionLabel={(route) => {
                  const routeSplits = route.split(".");
                  return routeSplits.length === 1
                    ? routeSplits[0]
                    : routeSplits[1];
                }}
                renderInput={(params) => (
                  <TextField {...params} size="small" label="Découpage" />
                )}
                onChange={(e, routes) => onChange(routes)}
                {...props}
              />
            )}
            name={`config.classification.queries.${index}.routes`}
            control={control}
          />
          {queries?.map((q, queryIndex) => (
            <ConfigClassificationQuery
              key={queryIndex}
              index={index}
              groupIndex={queryIndex}
              removeQuery={() => removeQuery(index)}
            />
          ))}
        </Stack>
      </CardContent>
    </Card>
  );
};
export default ConfigClassificationRoutedQuery;
